import React from "react"

import { useWebsiteBuilderV2 } from "../../WebsiteBuilderV2Context"

const KeywordsEditor = ({ onSave, onCancel }) => {
  const { clearPreview } = useWebsiteBuilderV2()

  const handleSubmit = () => {
    onSave({
      layout: "keywords",
      headline: "I help with",
      subheadline: "Specialized care for your needs",
      body: "",
      settings: {
        maxKeywords: 20,
        allowClick: true,
        keywords: []
      }
    })
  }

  return (
    <div
      className="relative box-border flex size-full flex-col content-stretch items-center justify-start bg-white shadow-[0px_8px_24px_0px_rgba(33,37,41,0.12)]"
      data-name="Keywords"
      data-node-id="1025:23393">
      {/* Form Content */}
      <div
        className="relative box-border flex w-full shrink-0 flex-col content-stretch items-start justify-start gap-6 px-8 pb-[120px] pt-6"
        data-name="form"
        data-node-id="1025:23395">
        <div
          className="relative flex w-[432px] shrink-0 flex-col content-stretch items-start justify-start gap-4"
          data-name="Builder / Keywords"
          data-node-id="1025:23396">
          <div
            className="relative flex w-full shrink-0 flex-col content-stretch items-start justify-start gap-0.5 leading-[0] text-[#0b3954]"
            id="node-I1025_23396-984_20635">
            <div
              className="relative w-full shrink-0 font-['Manrope:Bold',_sans-serif] text-[16px] font-bold"
              id="node-I1025_23396-984_20636">
              <p className="leading-[24px]">Keywords</p>
            </div>
            <div
              className="relative w-full shrink-0 font-['Manrope:Regular',_sans-serif] text-[14px] font-normal"
              id="node-I1025_23396-984_20637">
              <p className="leading-[20px]">
                <span className>{`Manage your keywords from the `}</span>
                <span className="text-[#0d9da4]">{`My Practice > Keywords`}</span>
                <span className>{` section.`}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Buttons */}
      <div
        className="absolute bottom-0 left-0 box-border flex w-[496px] content-stretch items-center justify-between bg-white p-[32px]"
        data-name="Button Bar"
        data-node-id="1025:23399">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 border-solid border-[#e4eff6] border-[1px_0px_0px]"
        />
        <div
          className="relative flex min-h-px min-w-px shrink-0 grow basis-0 content-stretch items-center justify-end gap-4"
          data-name="Actions"
          id="node-I1025_23399-3_769">
          <button
            className="relative box-border flex shrink-0 cursor-pointer content-stretch items-center justify-center gap-2 overflow-visible rounded-[4px] bg-white px-4 py-0"
            data-name="button/tertiary/small"
            id="node-I1025_23399-3_770"
            onClick={() => {
              clearPreview()
              onCancel()
            }}>
            <div
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 rounded-[4px] border border-solid border-[#c8d6df]"
            />
            <div
              className="relative shrink-0 text-nowrap font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[0] text-[#0b3954]"
              id="node-I1025_23399-3_770-3_1240">
              <p className="whitespace-pre leading-[32px]">Close</p>
            </div>
          </button>
          <button
            className="relative box-border flex shrink-0 cursor-pointer content-stretch items-center justify-center gap-2 rounded-[4px] bg-[#0d9da4] px-4 py-0"
            data-name="button/primary/small"
            id="node-I1025_23399-3_771"
            onClick={handleSubmit}>
            <div
              className="relative shrink-0 text-nowrap font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[0] text-white"
              id="node-I1025_23399-3_771-3_1214">
              <p className="whitespace-pre leading-[32px]">Save</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default KeywordsEditor
